import { cn } from '@/lib/utils'

export type ButtonVariant = 'primary' | 'secondary'

export type ButtonSize = 'sm' | 'md' | 'lg'

// Softly buttons: cocoa fill or cocoa outline, small 4px corners, slow gentle hovers.
export const buttonStyles = (variant: ButtonVariant = 'primary', size: ButtonSize = 'md', className?: string): string => cn(
    'inline-flex select-none items-center justify-center gap-2 whitespace-nowrap rounded-[4px] font-medium tracking-[0.01em]',
    'transition-[background-color,color,border-color,box-shadow,transform] duration-500 ease-out active:translate-y-px',
    'focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-cocoa disabled:pointer-events-none disabled:opacity-60',
    variant === 'primary' && 'bg-cocoa text-white shadow-[0_10px_24px_-14px_rgb(74_43_32/0.9)] hover:bg-[#5E3A2C]',
    variant === 'secondary' && 'border border-cocoa text-cocoa hover:bg-cocoa hover:text-white',
    size === 'sm' && 'h-9 px-4 text-[14px]',
    size === 'md' && 'h-11 px-5 text-[15px]',
    size === 'lg' && 'h-12 px-6 text-[16px]',
    className
)
